import React from 'react';
import AdminLayout from '../../../../Components/CommonComponents/Layout/adminLayout';
import JobFeesFormContainer from '../../../../Containers/AdminContainer/JobFees/JobFeesForm';
const JobFeesFormScreen = () => {
  return <JobFeesFormContainer />;
};

export default JobFeesFormScreen;
